import ClientConfigService from '@core/services/ClientConfigService';
import deepMerge from '@core/utils/deepMerge';

/**
 * Returns defaultConfig merged with client overrides for the component.
 * We do not cache the merged result here so that:
 * - Each caller gets the correct merge for its own defaultConfig (e.g. Card
 *   has full defaults, CardTitle only title.base).
 * - The first page that uses the component always gets client overrides,
 *   even if another component requested the same config earlier with a
 *   different default (e.g. before client was ready).
 * ClientConfigService still caches the raw client config per client:component.
 */
export async function getComponentConfig<
  T extends Record<string, unknown> = Record<string, unknown>,
>(componentName: string, defaultConfig: T = {} as T): Promise<T> {
  const clientConfig =
    await ClientConfigService.getComponentConfig(componentName);
  const baseConfig = structuredClone(defaultConfig);
  deepMerge(baseConfig, clientConfig);
  return baseConfig;
}
